import TabbedContent from "../Page/TabbedContent";

export default TabbedContent;
